const NOOP = () => { };

/**
 * Sorts an array with consideration of different languages.
 * @param array The array to be sorted.
 */
const intlSort = (array) => {
    try {
        return array.sort(Intl.Collator().compare);
    }
    catch (e) {
        // Fallback to localCompare when Intl.Collator().compare is not supported by a browser (e.g Android WebView).
        return array.sort((a, b) => a.localeCompare(b));
    }
};
/**
 * Sorts an array with consideration of different languages with an object property.
 * @param array The array to be sorted.
 * @param path Property of array item to be sorted by as an array path. To sort by `Object.user.entry.age` you pass `["user", "entry", "age"]`.
 */
const intlSortByProperty = (array, path) => {
    const get = (p, o) => p.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), o);
    try {
        return array.sort((a, b) => {
            return Intl.Collator().compare(get(path, a), get(path, b));
        });
    }
    catch (e) {
        // Fallback to localCompare when Intl.Collator().compare is not supported by a browser (e.g Android WebView).
        return array.sort((a, b) => {
            return get(path, a).localeCompare(get(path, b));
        });
    }
};

/*
 * Public API Surface of utility
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NOOP, intlSort, intlSortByProperty };
//# sourceMappingURL=play-utility.js.map
